<!-- giá trị trả vè fromDate  và toDate-->

<template>
  <div class="ms-date-range">
    <div :class="{ 'is-horizontal': isHorizontal }">
      <div
        class="period"
        :class="[classPeriod, { 'mr-15-px': isHorizontal, 'mb-8-px': !isHorizontal }]"
      >
        <ms-combobox
          :title="periodTitle"
          :showTitle="true"
          mode="dropdown"
          :data="dataRange"
          v-bind="$attrs"
          displayField="enumText"
          valueField="enumValue"
          queryMode="local"
          :disabled="isDisabled"
          @selected="selectedPeriod"
          v-model="selected"
        />
      </div>
      <div
        :class="[
          'flex',
          `${classDate ? classDate : isHorizontal ? 'is-horizontal-item' : 'w-full'}`, //ModifiedBy NNHung - 16/04/2020: Xét classDate trước khi xét isHorizontal để thuận tiện việc custom
        ]"
        v-if="showDatePicker"
      >
        <div class="w-1/2 mr-15-px date from-date">
          <ms-datepicker
            v-if="isShowFromDate"
            ref="fromDate"
            @blur="validData"
            :title="fromDateTitle"
            :showTitle="true"
            @change="changeDate"
            v-model="innerFromDate"
            rules="required"
            :disabled="isDisabled"
          ></ms-datepicker>
        </div>
        <div class="w-1/2 date to-date">
          <ms-datepicker
            ref="toDate"
            @blur="validData"
            :title="toDateTitle"
            @change="changeDate"
            v-model="innerToDate"
            rules="required"
            :showTitle="true"
            :disabled="isDisabled"
          ></ms-datepicker>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MsBaseComponent from "@/components/msbase/msBaseComponent.vue";
import { MSEnum } from "@/commons/enumeration";
import i18n from "@/i18ns/i18n";

// import VeeValidate, { ValidationObserver } from 'vee-validate';
import DateRange from "./DateRange.js";
//   import { ValidationProvider } from 'vee-validate';
let Period = MSEnum.Period;
export default {
  name: "MsDateRange",
  // components: { ValidationObserver,ValidationProvider },
  extends: MsBaseComponent,
  watch: {
    value(val) {
      if (this.selected != val) {
        this.selected = val;
      }
    },
    toDate(current, old) {
      if (!current) {
        var range = DateRange.caculateRangeFromPeriod(
          this.selected,
          this.innerFromDate,
          this.innerToDate,
        );
        this.$emit("update:toDate", range.toDate);
      } else {
        if (new Date(this.innerToDate).toDateString() != new Date(current).toDateString()) {
          //Sửa lỗi 70970
          this.innerToDate = new Date(current);
        }
      }
      this.$emit("changedDate", { ToDate: this.toDate });
    },
    fromDate(current, old) {
      if (!current) {
        var range = DateRange.caculateRangeFromPeriod(
          this.selected,
          this.innerFromDate,
          this.innerToDate,
        );
        this.$emit("update:fromDate", range.fromDate);
      } else {
        if (new Date(this.innerFromDate).toDateString() != new Date(current).toDateString()) {
          //Sửa lỗi 70970
          this.innerFromDate = new Date(current);
        }
      }
      this.$emit("changedDate", { FromDate: this.fromDate });
    },
    selected(current, oldValue) {
      // var periodItem = this.getPeriodItem(current);
      var periodItem = {};
      // if (this.checkIsExist(periodItem)) {
      var range = DateRange.caculateRangeFromPeriod(current, this.innerFromDate, this.innerToDate);
      periodItem.fromDate = range.fromDate;
      periodItem.toDate = range.toDate;
      // }
      this.$emit("update:fromDate", periodItem.fromDate);
      this.$emit("update:toDate", periodItem.toDate);
      this.$emit("update:period", current);
      this.$emit("input", current);
    },
  },
  props: {
    classPeriod: {
      default: "flex-1",
    },
    classDate: {
      // default: 'is-horizontal-item'
      default: "",
    },
    isHorizontal: {
      default: false,
      type: Boolean,
    },
    value: {
      type: [String, Number],
    },
    toDate: {
      type: [Date, String],
    },
    fromDate: {
      type: [Date, String],
    },
    fromDateTitle: {
      type: String,
      default() {
        return i18n.global.t("i18nCommon.FromDate");
      },
    },
    toDateTitle: {
      type: String,
      default() {
        return i18n.global.t("i18nCommon.ToDate");
      },
    },
    periodTitle: {
      type: String,
      default() {
        return i18n.global.t("i18nCommon.ReportTerm");
      },
    },
    showDatePicker: {
      type: Boolean,
      default: true,
    },
    //TTHuyen bổ sung thêm source data Custom cho combox chọn khoảng tgian
    dataSourcePeriod: {
      type: Array,
    },
    /*
     * Cờ đánh dấu có hiện control từ ngày lên hay không
     * pvduy 05/04/2021
     */
    isShowFromDate: {
      type: Boolean,
      default: true,
    },
    /**
     * customValidate
     * CreatedBy: tmquy (17/09/2021)
     */
    customValidate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  data() {
    return {
      innerFromDate: this.fromDate,
      innerToDate: this.toDate,
      selected: "",
      dataRange: [],
    };
  },
  methods: {
    /**
     * Valid range date
     */
    validData() {
      let me = this,
        isValid = true;

      if (!me.$refs.fromDate || !me.$refs.toDate) {
        return;
      }

      me.$refs.toDate.setError("");
      me.$refs.fromDate.setError("");

      if (!me.innerFromDate) {
        me.$refs.fromDate.setError(
          me.$t("i18nValidate").messages.required(me.$refs.fromDate.title),
        );
        isValid = false;
      }
      if (!me.innerToDate) {
        me.$refs.toDate.setError(me.$t("i18nValidate").messages.required(me.$refs.toDate.title));
        isValid = false;
      }
      if (isValid && me.customValidate == false) {
        var from = new Date(me.innerFromDate).toDateString();
        var to = new Date(me.innerToDate).toDateString();
        if (new Date(from).getDateOnly() > new Date(to).getDateOnly()) {
          let msg = `<${me.toDateTitle}> ${me.$t(
            "i18nCommon.NotSmallerThan",
          )} <${me.fromDateTitle}>`;
          me.$refs.toDate.setError(msg);
          isValid = false;
        } else if (typeof me.customValidateRules == "function") {
          isValid = me.customValidateRules(
            new Date(from).getDateOnly(),
            new Date(to).getDateOnly(),
            me,
          );
        } else {
          //btanh1 29/1/2020 mở lại đoạn này để sửa lỗi validate ngày. (không rõ vì sao vvkiet lại rem lai doan này)
          // me.$refs.toDate.$refs.provider.applyResult({
          // 	errors: [],
          // 	valid: true,
          // 	failedRules: {}
          // });
        }
      }
      return isValid;
    },

    /**
     * Kiểm tra xem item đã lưu innerFromDate innerToDate chưa
     */
    checkIsExist(item) {
      return (
        item.fromDate == undefined ||
        item.fromDate == null ||
        item.toDate == undefined ||
        item.toDate == null
      );
    },

    /**
     * Hàm thay đổi giá s
     */
    selectedPeriod(item, index) {
      let fromDate = this.fromDate;
      let toDate = this.toDate;
      item = item.newData; // nnlam thêm đoạn này do cơ chế ms-combobox nó thế
      // if (this.checkIsExist(item)) {
      if (item) {
        //NDQUAN: check tồn tại item
        var range = DateRange.caculateRangeFromPeriod(item.enumValue, fromDate, toDate);
        item.fromDate = range.fromDate;
        item.toDate = range.toDate;
        fromDate = range.fromDate;
        toDate = range.toDate;
        // } else {
        // 	fromDate = item.fromDate;
        // 	toDate = item.toDate;
        // }
        this.$emit("input", item.enumValue);
        // this.innerFromDate=fromDate;
        // this.innerToDate=toDate;
        this.$emit("update:fromDate", fromDate);
        this.$emit("update:toDate", toDate);

        this.$emit("updateDate", new Date(this.innerFromDate), new Date(this.innerToDate));
      }
    },
    /**
     * Hàm kiểm tra Khoảng dateRange ==> bindinf conbobox
     */
    checkRangeConvertToPeriod(item) {
      let me = this;
      if (
        new Date(me.innerFromDate).toDateString() == new Date(item.fromDate).toDateString() &&
        new Date(me.innerToDate).toDateString() == new Date(item.toDate).toDateString()
      ) {
        me.selected = item.enumValue;
        return true;
      }
      return false;
    },
    /**
     * Kiểm tra xem period đã được tính chưa
     */
    getPeriodItem(period) {
      let arrData = this.dataRange;
      for (var i = 0; i < arrData.length; i++) {
        if (arrData[i].enumValue == period) {
          return arrData[i];
        }
      }
    },
    /**
     * TThuyen
     * Thay đổi Khoảng thời gian
     */
    changeDate() {
      let me = this;
      let arrData = this.dataRange;
      this.selected = 0;
      for (var i = 0; i < arrData.length; i++) {
        // if (me.checkIsExist(arrData[i])) {
        //Thực hiện tính
        var range = DateRange.caculateRangeFromPeriod(arrData[i].enumValue);
        arrData[i].fromDate = range.fromDate;
        arrData[i].toDate = range.toDate;
        // }
        var isApprove = me.checkRangeConvertToPeriod(arrData[i]);
        if (isApprove) {
          break;
        }
      }
      //Update fromDate,toDate
      if (new Date(me.innerFromDate).toDateString() != new Date(me.fromDate).toDateString()) {
        me.$emit("update:fromDate", new Date(me.innerFromDate));
      }
      if (new Date(me.innerToDate).toDateString() != new Date(me.toDate).toDateString()) {
        me.$emit("update:toDate", new Date(me.innerToDate));
      }
      me.$emit("updateDate", new Date(me.innerFromDate), new Date(me.innerToDate));
      me.validData();
    },
  },
  mounted() {
    //TTHuyen 17.09.2020 bổ sung thêm props dataSourcePeriod chứa source data custom cho combo khoảng tgian.
    let x = this.$t("I18NDateRange");
    if (
      this.dataSourcePeriod &&
      Array.isArray(this.dataSourcePeriod) &&
      this.dataSourcePeriod.length > 0
    ) {
      this.dataRange = this.dataSourcePeriod;
    } else {
      for (let key in Period) {
        let obj = {
          enumText: x[key],
          enumValue: Period[key],
        };
        this.dataRange.push(obj);
      }
    }
    if (this.value != null && this.value != undefined) {
      this.selected = this.value;
    } else {
      this.selected = 45;
      this.$emit("input", this.selected);
    }
    //Mounted rangedate
    // this.$props.toDate=new Date();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/msDateRange.scss";
</style>
<style lang="scss" scoped>
.is-horizontal {
  display: flex;
}
.is-horizontal-item {
  width: 50%;
}
.ms-date-range {
  width: 100%;
}
.mr-15-px {
  margin-right: 15px;
}
.flex-1 {
  flex-grow: 1;
}
.mb-8-px {
  margin-bottom: 8px;
}
</style>
